import { Component, ErrorInfo, ReactNode } from "react"

// RELOAD-BANNER 2026-07-03: sibling of AIPanelErrorBoundary (same degrade-to-null pattern).
// The reload-banner logic is deliberately independent of auth/store, but it still must never
// be able to white-screen the app if it throws for any reason -- degrade to rendering nothing.
interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class NewVersionBannerErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.warn(
      "[NewVersionBannerErrorBoundary] reload banner crashed, rendering nothing",
      error,
      info
    )
  }

  render() {
    if (this.state.hasError) {
      return null
    }

    return this.props.children
  }
}

export default NewVersionBannerErrorBoundary
